export default "__VITE_ASSET__20054fa4__"